// extracted by mini-css-extract-plugin
export var desktopHeadline = "navigation-item-hs-module--desktopHeadline--28898";
export var desktopItems = "navigation-item-hs-module--desktop-items--7cce0";
export var mobileHeadline = "navigation-item-hs-module--mobileHeadline--07744";
export var mobileLinks = "navigation-item-hs-module--mobile-links--16bbc";
export var navigationItem = "navigation-item-hs-module--navigation-item--441a9";
export var navigationItemActive = "navigation-item-hs-module--navigation-item-active--cba99";
export var navigationItemHeadline = "navigation-item-hs-module--navigation-item-headline--2f4e0";
export var navigationItemLinks = "navigation-item-hs-module--navigation-item-links--df166";
export var navigationItemOne = "navigation-item-hs-module--navigation-item-one--2b261";
export var navigationItemTop = "navigation-item-hs-module--navigation-item-top--dc3c5";
export var navigationItemTwo = "navigation-item-hs-module--navigation-item-two--38bf0";
export var navigationItemWrapper = "navigation-item-hs-module--navigation-item-wrapper--adeb4";
export var navigationItems = "navigation-item-hs-module--navigation-items--aaa2b";
export var navigationLinkHeadline = "navigation-item-hs-module--navigation-link-headline--fb7ae";
export var navigationLinks = "navigation-item-hs-module--navigation-links--cdb1b";
export var productHeadline = "navigation-item-hs-module--product-headline--26809";